import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    const id = this.element.getAttribute('data-block-id')
    const timeout = this.element.getAttribute('data-timeout')
    const block = document.getElementById(id)

    if (block) {
      if (timeout) {
        setTimeout(() => { this.scrollToBottom(block) }, timeout)
      } else {
        this.scrollToBottom(block)
      }
    }

    this.scrollElementIntoView();
    this.scrollMatchIntoView();
  }

  scrollToBottom (block) {
    block.scrollTop = block.scrollHeight
  }

  scrollToTop () {
    const id = this.element.getAttribute('data-block-id');
    const block = id ? document.getElementById(id) : null;

    if (block) {
      block.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  scrollElementIntoView() {
    if (this.element.getAttribute('data-scroll-into-view') !== 'true') return;

    const block = this.element.getAttribute('data-scroll-block') || 'start';
    setTimeout(() => { this.element.scrollIntoView({ block }) }, 0);
  }

  scrollMatchIntoView() {
    const selector = this.element.getAttribute('data-scroll-to');
    if (!selector) return;

    setTimeout(() => {
      this.element.querySelector(selector)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  }
}
